import { CliMatch } from "@types";
import { makeResultKey } from "@utils";

import { CodeLoc, Highlight } from "@pages/editor/types";

import { makeHighlight } from "./makeHighlight";

export const makeMatchHighlight = (
  match: CliMatch,
  newEnd?: CodeLoc
): Highlight => ({
  ...makeHighlight(match.start, match.end, newEnd),
  key: makeResultKey(match),
  isError: false,
  type: newEnd ? "fix" : match.extra.severity,
  group: match.check_id,
  message: match.extra.message,
});
